import { AuthUser } from '../machine/types'
import { useAuthState } from './AuthProvider'

/** Current user identity, or `null` when no session is active. */
export const useUser = (): AuthUser | null => {
    const state = useAuthState()
    if (state.tag === 'authenticated' || state.tag === 'refreshing') {
        return state.session.claims.user
    }
    return null
}
